import makeComp from '../util/profiler';
import {Header} from 'semantic-ui-react';
import React from 'react';

export const BasicNoMatchComponent = makeComp<{}>(
  () => {
    return (
      <div className="nomatch">
        <Header>404</Header>
        <p>Looks like you stumbled on an empty page.</p>
      </div>
    );
  },
  {id: 'BasicNoMatch'}
);
